// @flow
import React, { Component } from "react";
import { prettyDate } from "../../../../utils/helpers";
import styles from "./NewsStory.module.css";
import CompanyLogo from "../../../shared/CompanyLogo/CompanyLogo";

type Props = { story: BreachStory };

type State = {};

class NewsStory extends Component<Props, State> {
  render() {
    const { story } = this.props;
    return (
      <div className={styles.story}>
        <div className={styles.topRow}>
          <span className={styles.date}>{prettyDate(story.published)}</span>
          <CompanyLogo className={styles.logo} companyUrl={story.url.url} />
        </div>
        <div className={styles.titleRow}>
          <a
            className={styles.title}
            href={story.url.url}
            target="_blank"
            rel="noopener noreferrer"
          >
            {story.story_title}
          </a>
        </div>
        <div className={styles.bottomRow}>
          <span>{story.description}</span>
          <a
            href={story.url.url}
            target="_blank"
            rel="noopener noreferrer"
            className={styles.metaUrl}
          >
            {story.url.url}
          </a>
        </div>
      </div>
    );
  }
}

export default NewsStory;



// WEBPACK FOOTER //
// ./src/components/Breach/BreachNews/NewsStory/NewsStory.js